import React, { useState, useContext, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Form, Table, Modal, Alert } from 'react-bootstrap';
import { observer } from 'mobx-react-lite';
import { Context } from '../index';
import { fetchTypes, fetchBrands, fetchDevices, createType, createBrand, createDevice, deleteDevice } from '../http/deviceAPI';

const Admin = () => {
    const { device } = useContext(Context);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState('');
    const [formData, setFormData] = useState({
        name: '',
        price: '',
        brandId: '',
        typeId: '',
        img: null,
        description: ''
    });
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchTypes().then(data => device.setTypes(data));
        fetchBrands().then(data => device.setBrands(data));
        fetchDevices().then(data => device.setDevices(data.rows || data));
    }, []);

    const handleOpenModal = (type) => {
        setModalType(type);
        setFormData({ name: '', price: '', brandId: '', typeId: '', img: null, description: '' });
        setMessage('');
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setFormData({ name: '', price: '', brandId: '', typeId: '', img: null, description: '' });
        setMessage('');
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        setFormData({ ...formData, img: e.target.files[0] });
    };

    // Функция для удаления товара
    const handleDelete = async (id) => {
        if (window.confirm('Вы уверены, что хотите удалить этот товар?')) {
            try {
                await deleteDevice(id);
                setMessage('✅ Товар удалён!');
                const devices = await fetchDevices();
                device.setDevices(devices.rows || devices);
                setTimeout(() => setMessage(''), 3000);
            } catch (error) {
                console.error('Ошибка удаления:', error);
                setMessage('❌ Ошибка удаления товара');
                setTimeout(() => setMessage(''), 3000);
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');

        try {
            if (modalType === 'type') {
                if (!formData.name) {
                    setMessage('❌ Введите название типа');
                    setLoading(false);
                    return;
                }
                await createType({ name: formData.name });
                setMessage('✅ Тип успешно добавлен!');
                const types = await fetchTypes();
                device.setTypes(types);
                setTimeout(handleCloseModal, 1500);
            } else if (modalType === 'brand') {
                if (!formData.name) {
                    setMessage('❌ Введите название бренда');
                    setLoading(false);
                    return;
                }
                await createBrand({ name: formData.name });
                setMessage('✅ Бренд успешно добавлен!');
                const brands = await fetchBrands();
                device.setBrands(brands);
                setTimeout(handleCloseModal, 1500);
            } else if (modalType === 'device') {
                const formDataSend = new FormData();
                formDataSend.append('name', formData.name);
                formDataSend.append('price', formData.price);
                formDataSend.append('brandId', formData.brandId);
                formDataSend.append('typeId', formData.typeId);
                formDataSend.append('description', formData.description || '');
                if (formData.img) {
                    formDataSend.append('img', formData.img);
                }
                await createDevice(formDataSend);
                setMessage('✅ Устройство успешно добавлено!');
                const devices = await fetchDevices();
                device.setDevices(devices.rows || devices);
                setTimeout(handleCloseModal, 1500);
            }
        } catch (error) {
            console.error('❌ Ошибка:', error);
            setMessage('❌ ' + (error.response?.data?.message || 'Ошибка добавления'));
        }
        setLoading(false);
    };

    return (
        <Container className="mt-4">
            <h1 className="mb-4">⚙️ Админ панель</h1>

            <Row className="mb-4">
                <Col md={4}>
                    <Card className="text-center shadow-sm">
                        <Card.Body>
                            <Card.Title>📱 Устройства</Card.Title>
                            <Card.Text>Добавить новый товар</Card.Text>
                            <Button variant="dark" onClick={() => handleOpenModal('device')}>Добавить</Button>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="text-center shadow-sm">
                        <Card.Body>
                            <Card.Title>🏷️ Типы</Card.Title>
                            <Card.Text>Добавить категорию</Card.Text>
                            <Button variant="dark" onClick={() => handleOpenModal('type')}>Добавить</Button>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="text-center shadow-sm">
                        <Card.Body>
                            <Card.Title>🏢 Бренды</Card.Title>
                            <Card.Text>Добавить бренд</Card.Text>
                            <Button variant="dark" onClick={() => handleOpenModal('brand')}>Добавить</Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {message && <Alert variant={message.includes('✅') ? 'success' : 'danger'}>{message}</Alert>}

            <h2 className="mb-3">📦 Список товаров</h2>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Название</th>
                        <th>Цена</th>
                        <th>Рейтинг</th>
                        <th>Бренд</th>
                        <th>Тип</th>
                        <th>Действие</th>
                    </tr>
                </thead>
                <tbody>
                    {device.devices && device.devices.length > 0 ? (
                        device.devices.map((item) => (
                            <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{item.name}</td>
                                <td>{item.price} ₽</td>
                                <td>⭐ {item.rating}</td>
                                <td>{item.brandId || '—'}</td>
                                <td>{item.typeId || '—'}</td>
                                <td>
                                    <Button 
                                        variant="danger" 
                                        size="sm"
                                        onClick={() => handleDelete(item.id)}
                                    >
                                        🗑️ Удалить
                                    </Button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="7" className="text-center">Товаров пока нет</td>
                        </tr>
                    )}
                </tbody>
            </Table>

            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {modalType === 'type' && '➕ Добавить тип'}
                        {modalType === 'brand' && '➕ Добавить бренд'}
                        {modalType === 'device' && '➕ Добавить устройство'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {message && <Alert variant={message.includes('✅') ? 'success' : 'danger'}>{message}</Alert>}
                    <Form onSubmit={handleSubmit}>
                        {(modalType === 'type' || modalType === 'brand') && (
                            <Form.Group className="mb-3">
                                <Form.Label>Название</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    placeholder="Введите название..."
                                    required
                                    autoFocus
                                />
                            </Form.Group>
                        )}

                        {modalType === 'device' && (
                            <>
                                <Form.Group className="mb-3">
                                    <Form.Label>Название</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Цена</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="price"
                                        value={formData.price}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Описание</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        name="description"
                                        value={formData.description}
                                        onChange={handleInputChange}
                                        placeholder="Введите описание товара..."
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Бренд</Form.Label>
                                    <Form.Select
                                        name="brandId"
                                        value={formData.brandId}
                                        onChange={handleInputChange}
                                        required
                                    >
                                        <option value="">Выберите бренд</option>
                                        {device.brands && device.brands.map(brand => (
                                            <option key={brand.id} value={brand.id}>
                                                {brand.name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Тип</Form.Label>
                                    <Form.Select
                                        name="typeId"
                                        value={formData.typeId}
                                        onChange={handleInputChange}
                                        required
                                    >
                                        <option value="">Выберите тип</option>
                                        {device.types && device.types.map(type => (
                                            <option key={type.id} value={type.id}>
                                                {type.name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Изображение</Form.Label>
                                    <Form.Control
                                        type="file"
                                        name="img"
                                        onChange={handleFileChange}
                                    />
                                </Form.Group>
                            </>
                        )}

                        <Button variant="dark" type="submit" disabled={loading} className="w-100">
                            {loading ? '⏳ Загрузка...' : '✅ Добавить'}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </Container>
    );
};

export default observer(Admin);
